'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var classMap = {
  xs: 'col-xs-',
  sm: 'col-sm-',
  md: 'col-md-',
  lg: 'col-lg-',
  xsOffset: 'col-xs-offset-',
  smOffset: 'col-sm-offset-',
  mdOffset: 'col-md-offset-',
  lgOffset: 'col-lg-offset-',
  first: 'first-',
  last: 'last-'
};

var Col = function Col(_ref) {
  var children = _ref.children,
      reverse = _ref.reverse,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, ['children', 'reverse', 'className']);

  var classes = [];

  if (className) {
    classes.push(className);
  }

  if (reverse) {
    classes.push('reverse');
  }

  var passingProps = {};
  Object.keys(other).forEach(function (key) {
    if (classMap[key]) {
      var value = other[key];
      if (typeof value !== 'undefined') {
        classes.push('' + classMap[key] + value);
      }
    } else {
      passingProps[key] = other[key];
    }
  });

  return (0, _react.createElement)('div', Object.assign({}, passingProps, {
    className: classes.join(' ')
  }), children);
};

Col.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  xs: _propTypes2.default.number,
  sm: _propTypes2.default.number,
  md: _propTypes2.default.number,
  lg: _propTypes2.default.number,
  xsOffset: _propTypes2.default.number,
  smOffset: _propTypes2.default.number,
  mdOffset: _propTypes2.default.number,
  lgOffset: _propTypes2.default.number,
  reverse: _propTypes2.default.bool,
  first: _propTypes2.default.string,
  last: _propTypes2.default.string
};

exports.default = Col;